import React, { useState } from "react";
import ModalAddStep from "../../settings/modal_add_step/ModalAddStep";
import ModalEditStep from "../../settings/modal_edit_step/ModalEditStep";
import HtmlText from "../html-text/HtmlText";

const LinkModalColumn = ({ column, htmlContent, tenantId, action }) => {
  const [showModalInfo, setShowModalInfo] = useState(false);

  return (
    <React.Fragment>
      <span onClick={() => setShowModalInfo(true)}>
        <HtmlText htmlText={htmlContent} />
      </span>
      {action === "update" && (
        <ModalEditStep
          isModalVisible={showModalInfo}
          columnId={column.id}
          onCancelModal={() => setShowModalInfo(false)}
          tenantId={tenantId}
          modalTitle={column.name}
          column={column}
        />
      )}

      {action === "create" && (
        <ModalAddStep
          isModalVisible={showModalInfo}
          onCancelModal={() => setShowModalInfo(false)}
          tenantId={tenantId}
          modalTitle={name}
        />
      )}
    </React.Fragment>
  );
};

export default LinkModalColumn;
